<template>
  <button
    :disabled="disabled"
    :class="{ 'disabled': disabled }"
    @click="onClick"
    class="form-button ignore-design"
    type="button"
  >
    {{ label }}
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    onClick: {
      type: Function,
      required: true
    }
  }
}
</script>

<style lang="scss">
  .container__buttons {

    .form-button {
      @include form-button;
    }

    .disabled {
      @include form-button-disabled;
    }

    .next {
      @include form-button-enabled;

      &:hover:not(.disabled) {
        @include form-button-enabled-hover;
      }
    }

    .previous {
      @include form-button-outline;

      &:hover {
        @include form-button-outline-hover;
      }
    }
  }

</style>
